import React from 'react';
import PropTypes from 'prop-types';
import { LoadingSpinner } from 'components/common';
import SummaryCard from '../components/SummaryCard';
import { BarList, MonthlyBars } from '../components/MiniCharts';
import OverviewDetailGrid from '../OverviewDetailGrid';

// Waiver tab: status breakdown + overdue aging + monthly trend, then detail.
const WaiverTab = ({ data, loading, baseParams }) => {
  const status  = (data?.status || []).map((s) => ({ label: s.status, value: s.count }));
  const aging   = (data?.overdue?.aging || []).map((a) => ({ label: a.label, value: a.count }));
  const overdue = data?.overdue?.count || 0;
  const trend   = (data?.trend || []).map((t) => ({ label: t.label, value: t.total }));

  if (loading && !data) return <div className="tw-text-center tw-py-12"><LoadingSpinner /></div>;

  return (
    <>
      <div className="tw-grid tw-grid-cols-12 tw-gap-3 tw-mb-3">
        <div className="tw-col-span-12 lg:tw-col-span-6">
          <SummaryCard title="Waiver Status" subtitle="By approval status">
            <div className="tw-col-span-12"><BarList items={status} color="#6366f1" /></div>
          </SummaryCard>
        </div>
        <div className="tw-col-span-12 lg:tw-col-span-6">
          <SummaryCard title="Overdue Aging" subtitle={`${overdue} overdue waivers`}>
            <div className="tw-col-span-12"><BarList items={aging} color="#f43f5e" /></div>
          </SummaryCard>
        </div>
      </div>
      <SummaryCard title="Monthly Waivers" subtitle="Waivers created per month">
        <div className="tw-col-span-12"><MonthlyBars items={trend} valueKey="value" color="#6366f1" /></div>
      </SummaryCard>
      <OverviewDetailGrid section="waiver" title="Waiver Records" baseParams={baseParams} />
    </>
  );
};

WaiverTab.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  baseParams: PropTypes.object.isRequired
};
WaiverTab.defaultProps = { data: null, loading: false };

export default WaiverTab;
